import {
  cardSx,
  cardContentSx,
  searchFieldSx
} from '../../../../Common/components/Styles/InputStyles';

export const detailsCardSx = {
  ...cardSx,
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
  overflow: 'hidden',
  width: '100%'
};

export const detailsHeaderWrapperSx = {
  flexShrink: 0,
  p: 0
};

export const detailsSearchFieldSx = {
  ...searchFieldSx,
  width: 320
};

export const searchIconSx = {
  color: '#757575',
  fontSize: 18
};

export const detailsCardContentSx = {
  ...cardContentSx,
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: 0,
  overflow: 'hidden',
  p: 0,

  '&:last-child': {
    pb: 0
  }
};